import { render, staticRenderFns } from "./lawdetmorexg.vue?vue&type=template&id=2bfcc21d&scoped=true&"
import script from "./lawdetmorexg.vue?vue&type=script&lang=js&"
export * from "./lawdetmorexg.vue?vue&type=script&lang=js&"
import style0 from "./lawdetmorexg.vue?vue&type=style&index=0&id=2bfcc21d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcc21d",
  null
  
)

export default component.exports